import { AnalyticsProps } from '../../InternalLibrary/analytics';
import { Link, LinkProps } from 'components/atoms/Link/Link';
import { PropsWithChildren, useCallback } from 'react';
import Spacer from 'components/atoms/Spacer/Spacer';
import styles from 'components/atoms/Link/Link.module.scss';
import Text from 'components/atoms/Typography/Text';
import useEventCollector from '../../hooks/eventCollector/useEventCollector';

export interface LinkActorPros extends AnalyticsProps {
  error?: string;
  className?: string;
  linkProps?: Partial<LinkProps>;
  width?: string;
}

export const LinkActor: React.FC<PropsWithChildren<LinkActorPros>> = ({
  error,
  className,
  linkProps = {},
  children,
  width,
}) => {
  const { track } = useEventCollector();

  const onClick = useCallback(
    (e: any) => {
      linkProps?.onClick?.(e);
    },
    [linkProps, children, track],
  );
  // TODO: Style it
  return (
    <div style={{ width }} className={className}>
      <Link {...linkProps} onClick={onClick}>
        {children}
      </Link>
      {error && (
        <Spacer marginVertical="10px">
          <Text
            kind="p"
            level={2}
            className={styles['error-text']}
            dangerouslySetInnerHTML={{
              __html: error,
            }}
          />
        </Spacer>
      )}
    </div>
  );
};
